import { render, staticRenderFns } from "./EmailSendingModal.vue?vue&type=template&id=37e7ae39&scoped=true&"
import script from "./EmailSendingModal.vue?vue&type=script&lang=js&"
export * from "./EmailSendingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e7ae39",
  null
  
)

export default component.exports